<template>
  <div class="automate-hr">
    <SectionHeader class="automate-header max-w-4xl mx-auto px-6 px-8">
      <template #header>
        <div class="header-text text-left md:text-center mb-4">
          The Most Important
          <span style="color: #8e6baf">
            <span style="white-space: nowrap">HR Practices for</span>
            <span style="white-space: nowrap">Small Businesses</span>
          </span>
          on Autopilot
        </div>
      </template>
      <template #subheader>
        <div class="text-left md:text-center">
          Today, Bambee's HR Autopilot keeps over 10,000 American Businesses HR
          compliant all year long, with up-to-date HR policies, mandatory
          training, and regular, two-way feedback between you and your
          employees.
        </div>
      </template>
    </SectionHeader>
    <div
      v-for="(item, index) in Automations"
      :id="item.id"
      :key="`automation-${index}`"
      class="text-image-block flex items-center max-w-5xl mx-auto pt-12 md:pt-20"
      :class="
        index % 2 ? 'flex-col sm:flex-row-reverse' : 'flex-col sm:flex-row'
      "
    >
      <div
        class="text-block flex w-100 shrink-0 sm:w-1/2 justify-center px-6 py-4 sm:px-8"
      >
        <div class="text-wrap max-w-none md:max-w-sm">
          <TypeOverline
            :variant="$options.Typography.Overline.LARGE"
            tag="p"
            class="block-header w-fit border-b-2 border-primary mb-4 pb-1 text-primary whitespace-nowrap"
          >
            {{ item.header }}
          </TypeOverline>
          <TypeDisplay
            :variant="$options.Typography.Display.MEGA"
            :weight="$options.Typography.Weights.STRONG"
            tag="p"
            class="title leading-snug mb-4"
          >
            {{ item.title }}
          </TypeDisplay>
          <TypeBody
            :variant="$options.Typography.Body.MEDIUM"
            :weight="$options.Typography.Weights.REGULAR"
            tag="p"
            class="body"
          >
            {{ item.body }}
          </TypeBody>
        </div>
      </div>
      <div class="image-block flex justify-center w-100 sm:w-1/2">
        <div class="image-wrap max-w-md">
          <img
            :src="item.image"
            alt="block-image"
            class="image max-w-xs md:max-w-sm px-6 py-4 sm:px-8"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import {
  constants,
  TypeBody,
  TypeDisplay,
  TypeOverline,
} from '@bambeehr/pollen';
import SectionHeader from './SectionHeader';

import { Automations } from '@/modules/HomePage/constants';

const { Typography } = constants;

export default defineComponent({
  name: 'AutomateHr',
  Typography,
  components: {
    SectionHeader,
    TypeBody,
    TypeDisplay,
    TypeOverline,
  },
  setup() {
    return {
      Automations,
    };
  },
});
</script>
